import type { EntityConfig } from '../types'

export const billingScheduleEntity: EntityConfig = {
  id: 'billing-schedule',
  displayName: 'Billing Schedule',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'draft', label: 'Draft' },
      { value: 'completed', label: 'Completed' },
      { value: 'archived', label: 'Archived' }
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'draft', label: 'Draft', color: 'pending' },
      { value: 'completed', label: 'Completed', color: 'info' },
      { value: 'archived', label: 'Archived', color: 'neutral' }
    ],
    mappings: {
      all: ['active', 'draft', 'completed', 'archived'],
      active: ['active'],
      draft: ['draft'],
      completed: ['completed'],
      archived: ['archived']
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    amount: { type: 'amount', urlKey: 'amount' },
    customerId: { type: 'search', urlKey: 'customerId' },
    intervalType: { type: 'string_array', urlKey: 'intervalType' },
    createdDate: { type: 'date_range', urlKey: 'createdDate' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'amount',
    'dateRange',
    'intervalType',
  ]
}
